import React, { memo } from 'react';
import styles from './DataTableFilterDrawerHeader.module.scss';

interface DataTableFilterDrawerHeaderProps {
    title?: string;
    onClose?: () => void;
}

const DataTableFilterDrawerHeader: React.FC<DataTableFilterDrawerHeaderProps> = ({ title = 'Filters', onClose }) => {
    return (
        <div className={styles.Header}>
            <h2 className={styles.Title}>{title}</h2>
        </div>
    );
};

export default memo(DataTableFilterDrawerHeader);
